"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigCommon = void 0;
const featureFlag_1 = require("../featureFlag");
class ConfigCommon {
    constructor() {
        this.featureFlagPlatform = featureFlag_1.FeatureFlagPlatform.WEB;
        this.getLoginDomain = () => window.LOGIN_DOMAIN;
        this.getMiddlewareBaseHost = () => window.MIDDLEWARE_BASE_HOST;
        this.getTranslationsServiceHost = () => this.getMiddlewareBaseHost() + '/mb-api-translations';
        this.getFeatureFlagServiceHost = () => this.getMiddlewareBaseHost() + '/mb-api-feature-flag';
        this.getFeatureFlagConfig = () => {
            return {
                bank: featureFlag_1.FeatureFlagBanks.BANK_MX,
                platform: featureFlag_1.FeatureFlagPlatform.WEB,
                featureFlagServiceHost: this.getFeatureFlagServiceHost(),
            };
        };
    }
}
exports.ConfigCommon = ConfigCommon;
//# sourceMappingURL=configsBase.js.map